import commonBaseSetBg from './assets/common-base-set-bg.webp';
import winterSetBg from './assets/winter-set-bg.webp';

type Props = {
  set: Nullable<string>;
};

const SET_BACKGROUNDS = {
  'common-base-set': commonBaseSetBg,
  winter: winterSetBg,
} as const;

const isSetBackground = (
  set: Nullable<string>
): set is keyof typeof SET_BACKGROUNDS => {
  if (!set) {
    return false;
  }
  return set in SET_BACKGROUNDS;
};

export const CollectionSetBackground = ({ set }: Props) => {
  if (!isSetBackground(set)) {
    return null;
  }
  return <img src={SET_BACKGROUNDS[set]} alt={set} />;
};
